import React from "react"
//import LandingPage from "../components/LandingPage"
import LandingPage from "../components/Home"

const IndexScreen = props => {
  return <LandingPage session={props.session} />
}

export default IndexScreen
